import { z } from 'zod';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { singleDieSchema } from '../SharedZodSchemas.ts';
import { validateState } from '../ValidateState.ts';
export const mechanicEventDiceStateSchema = z.object({
    eventDice: singleDieSchema
}).strict();
export function validateMechanicEventDiceState(data) {
    return validateState(mechanicEventDiceStateSchema, data);
}
export const mechanicEventDiceStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicEventDiceStateSchema);
